/**
 * Booking Status Table Component
 *
 * A table showing booking status breakdown for grooming services with status name,
 * total count with percentage, and order value. Uses V3 Table components for consistency.
 */

import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import styles from './BookingStatusTable.module.scss';

// Data structure for booking status
interface BookingStatus {
    name: string;
    total: number;
    percentage: number;
    orderValue: string;
}

// Mock data matching the design
const bookingStatusData: BookingStatus[] = [
    { name: 'Booked', total: 77, percentage: 44, orderValue: '$16,678' },
    { name: 'Confirmed', total: 33, percentage: 15, orderValue: '$13,111' },
    { name: 'Arrived', total: 16, percentage: 7, orderValue: '$6,590' },
    { name: 'Started', total: 6, percentage: 7, orderValue: '$3,882' },
    { name: 'Completed', total: 3, percentage: 2, orderValue: '$1,712' },
    { name: 'Canceled', total: 2, percentage: 1, orderValue: '$442' },
    { name: 'No Show', total: 3, percentage: 1, orderValue: '$350' }
];

export const BookingStatusTable: React.FC = () => {
    const [selectedService, setSelectedService] = useState('Grooming services');

    return (
        <div className={styles.tableContainer}>
            {/* Table Header */}
            <div className={styles.tableHeader}>
                <div className={styles.headerContent}>
                    <h3 className={styles.tableTitle}>Booking status {selectedService}</h3>
                </div>
            </div>

            {/* Data Table */}
            <div className={styles.tableWrapper}>
                <Table className={styles.table}>
                    <TableHeader>
                        <TableHeaderCell className={styles.nameColumn}>Name</TableHeaderCell>
                        <TableHeaderCell className={styles.totalColumn}>Total</TableHeaderCell>
                        <TableHeaderCell className={styles.orderValueColumn}>Order value</TableHeaderCell>
                    </TableHeader>

                    <TableBody>
                        {bookingStatusData.map((status, index) => (
                            <TableRow key={index}>
                                <TableCell className={styles.nameCell}>{status.name}</TableCell>
                                <TableCell className={styles.totalCell}>
                                    <span className={styles.totalValue}>
                                        {status.total} ({status.percentage}%)
                                    </span>
                                </TableCell>
                                <TableCell className={styles.orderValueCell}>{status.orderValue}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};
